import { defineComponent as n, ref as f, computed as t, createElementBlock as r, openBlock as c, normalizeClass as d, renderSlot as s } from "vue";
import { DEFAULT_OFFSET as u, DEFAULT_DELAY as m } from "./constants.js";
import { useTooltip as p } from "./useTooltip.js";
const i = {}, v = /* @__PURE__ */ n({
  ...i,
  __name: "ScalarTooltip",
  props: {
    content: { default: "" },
    delay: { default: () => m },
    placement: { default: "top" },
    offset: { default: () => u }
  },
  setup(l) {
    const o = f(null);
    return p({
      content: t(() => l.content),
      delay: t(() => l.delay),
      placement: t(() => l.placement),
      offset: t(() => l.offset),
      targetRef: t(
        () => {
          var e, a;
          return ((a = (e = o.value) == null ? void 0 : e.children) == null ? void 0 : a[0]) || o.value || void 0;
        }
      )
    }), (e, a) => (c(), r("div", {
      ref_key: "wrapperRef",
      ref: o,
      class: d({ contents: !!e.$slots.default })
    }, [
      s(e.$slots, "default")
    ], 2));
  }
});
export {
  v as default
};
